export default __webpack_public_path__ + "static/media/lea-abel.7d8eef48.jpg";